// "PVP a consultar": el articulo del catalogo Fegime no tiene precio publicado
// (no_price) o ya se materializo y sigue sin precio. No puede anadirse al
// carrito: la linea entraria a 0 €. El back lo para igualmente
// (Product::isFegimeWithoutPrice, ShoppingCartService::addProduct).
//
// price permite pasar el precio que pinta la card/ficha (variantes, descuentos)
// en vez del del producto.
export function hasNoSalePrice(product, price = null) {
  if (!product) return false;

  // Articulo virtual (todavia no existe en la web): manda el flag del payload.
  if (product.is_fegime) return !!product.no_price;

  if (!product.created_from_fegime) return false;

  const value = parseFloat(price !== null ? price : product.price);

  return !(value > 0);
}

// Materializa (idempotente, POST fegime-materialize-product) un articulo del
// catalogo Fegime como producto de la web y devuelve su product_id, o null si
// falla. El producto (card del buscador o ficha virtual) viaja con is_fegime,
// fegime_code y materialize_url en su payload; el id resultante se cachea en
// el propio objeto para no repetir la peticion (add-to-cart + wishlist).
export async function materializeFegimeProduct(product) {
  if (product.materialized_id) {
    return product.materialized_id;
  }

  try {
    const csrf = document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content");

    // Sin token la peticion sale con "X-CSRF-TOKEN: undefined" y Laravel
    // responde 419: mejor no enviarla y dejar el motivo en la consola.
    if (!csrf) {
      console.error(
        "No se ha podido crear el producto Fegime: falta el meta csrf-token en la pagina."
      );

      return null;
    }

    const response = await fetch(product.materialize_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-TOKEN": csrf,
        Accept: "application/json",
      },
      body: JSON.stringify({codigo_fegime: product.fegime_code}),
    });

    const data = await response.json();

    if (!data || data.status !== 1 || !data.product_id) {
      throw new Error("materialize failed");
    }

    product.materialized_id = data.product_id;

    return data.product_id;
  } catch (error) {
    console.error("No se ha podido crear el producto Fegime:", error);
    return null;
  }
}
